import styled from 'styled-components'

export const AboutWrapper = styled.div`
	width: 50%;
	display: flex;
	flex-direction: column;
`
